export default class UserPlaformStatusChange {
    public id = 0
    public serialOrEmail = ''
    public scopeAffected = 0
    public userStatus = 0
    public borradoTotal = false
    public hacerCopiaBD = false
    public emailConfirmed = -1
    public apiUrl = ''
    // public isBlockedUser = false
    // public isEmailConfirmed = false
}
